import { SxProps } from '@mui/material';
import { green, green1, green2, grey11Opacity85 } from 'app/components/ThemeProvider/colors';
import { red2 } from '../../ThemeProvider/colors';
import {getTheme} from "app/components/ThemeProvider/theme";

const theme = getTheme('light');

export const docInfoBox: SxProps = {
  background: grey11Opacity85,
  borderRadius: '8px',
  display: 'flex',
  gap: '8px',
  p: '8px 12px',
  alignItems: 'center',
  height: '35px',
};
export const lineBorder: SxProps = {
  border: '1px dashed #eaeaea',
  width: '100%',
  mt: '28px',
};
export const docInfoText: SxProps = {
  fontSize: '15px',
  color: red2,
  lineHeight: '1',
};

export const detailsBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '54px',
};

export const detailsBtns: SxProps = {
  display: 'flex',
  gap: '12px',
  color: green,
  background: green1,
  '&:hover': { background: green2 },
};

export const balanceWithBtnsBox: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    alignItems: 'normal',
    gap: '20px'
  },
}
export const detailsWraper: SxProps = {
  display: 'flex', flexDirection: 'row', gap: '60px', mt: '28px',flexWrap: 'wrap',
  [theme.breakpoints.down(448)]: {
    flexDirection: 'column',
    gap: '16px'
  },
}

export const accordionDetail: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 28px 32px',
  [theme.breakpoints.down("lg")]: {
    padding: '0px 20px 32px',
  },
}